import React, { useContext } from "react";
import style from "./DynamicInput.module.css";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../store";

function DynamicInput(props) {
  const { PersonalStore } = useContext(RootStoreContext);
  const { deeds, handleInputChange, removeInput, addInput, updateData } =
    PersonalStore;

  return (
    <div className={style.container}>
      <div className={style.label}>
        <div>{props.label}</div>
        <button onClick={addInput} className={style.roundBtn}>
          +
        </button>
        <button onClick={removeInput} className={style.roundBtn}>
          -
        </button>
      </div>
      {deeds.map((item, i) => {
        return (
          <input
            onChange={(e) => {
              handleInputChange(e.target.value, i);
              updateData("deeds", e.target.value);
            }}
            value={item}
            key={`input${i}`}
            size="40"
            className={style.inputBtn}
          />
        );
      })}
    </div>
  );
}

export default observer(DynamicInput);
